/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
  useState,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';
// ---
import npsAction from '../../../broadcast/actions/nps';
import submitAction from '../../../broadcast/actions/submit';
// import { Init } from '../../../broadcast'

const StyledBackdrop = styled.div(
  props => `
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: ${props.view};
  /*
  z-index: 9002;
  */
`
);

/**
 * embedded Inquiry 背景黒透明
 * @param {*} [nps={}] Redux.store.nps
 * @param {*} [submit={}] Redux.store.submit
 * @param {boolean} [embedded=false] embedded flag
 * @param {boolean} [storybook=false] storybook flag
 * @return {*} React.node
 * @constructor
 */
const Backdrop = ({
  nps = {},
  submit = {},
  embedded = false,
  storybook = false,
}) => {
  const [show, setShow] = useState(false);

  const getDisplay = useCallback(() => {
    return show && embedded ? 'block' : 'none';
  }, [show, embedded]);

  useEffect(() => {
    // console.log('Backdrop.useEffect - show / nps', show, nps.type);
    if (!show && nps.type === npsAction.type.CHANGE) {
      setShow(true);
    }
  }, [show, setShow, nps]);

  useEffect(() => {
    // console.log('Backdrop.useEffect - show / submit', show, submit.type);
    if (
      show &&
      (submit.type === submitAction.type.COMPLETE ||
        submit.type === submitAction.type.CLOSE)
    ) {
      setShow(false);
    }
  }, [show, setShow, submit]);

  return (
    <StyledBackdrop
      className={'Backdrop'}
      view={storybook ? 'block' : getDisplay()}
    />
  );
};

export default Backdrop;



// WEBPACK FOOTER //
// ./src/embedded-type/survey/page/backdrop/Backdrop.js